import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import authService from 'services/authService';
import Swal from 'sweetalert2';
import "views/signIn/SignIn.css";

export const SignUp = () => {
    const navigate = useNavigate();
    const { setIsLogged, setStorage } = useAuth();

    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        password: '',
        confirmPassword: '',
        rfc: '',
        razonSocial: '',
        telefono: '',
        direccion: ''
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        }
    });

    const showError = (message) => {
        Toast.fire({
            icon: 'error',
            title: message
        });
    };

    const showSuccess = (message) => {
        Toast.fire({
            icon: 'success',
            title: message
        });
    };


    const validateEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const validateRFC = (rfc) =>
        /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/.test(rfc.toUpperCase());

    const validatePhone = (phone) =>
        /^[\d\s\-\(\)]{10,}$/.test(phone);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.nombre.trim())
            newErrors.nombre = 'El nombre es requerido';
        else if (formData.nombre.trim().length < 3)
            newErrors.nombre = 'El nombre debe tener al menos 3 caracteres';

        if (!formData.email.trim())
            newErrors.email = 'El correo electrónico es requerido';
        else if (!validateEmail(formData.email))
            newErrors.email = 'Ingresa un correo electrónico válido';

        if (!formData.password)
            newErrors.password = 'La contraseña es requerida';
        else if (formData.password.length < 6)
            newErrors.password = 'La contraseña debe tener al menos 6 caracteres';

        if (!formData.confirmPassword)
            newErrors.confirmPassword = 'Confirma tu contraseña';
        else if (formData.password !== formData.confirmPassword)
            newErrors.confirmPassword = 'Las contraseñas no coinciden';

        if (!formData.rfc.trim())
            newErrors.rfc = 'El RFC es requerido';
        else if (!validateRFC(formData.rfc))
            newErrors.rfc = 'Ingresa un RFC válido (ej: XAXX010101000)';

        if (!formData.razonSocial.trim())
            newErrors.razonSocial = 'La razón social es requerida';

        if (formData.telefono && !validatePhone(formData.telefono))
            newErrors.telefono = 'Ingresa un número de teléfono válido';

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            showError('Corrige los errores del formulario');
            return false;
        }

        return true;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        let newValue = value;

        if (name === 'rfc') {
            newValue = value.toUpperCase();
        }

        setFormData(prev => ({
            ...prev,
            [name]: newValue
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        try {
            const { confirmPassword, ...dataToSend } = formData;

            const result = await authService.register({
                ...dataToSend,
              //  razonSocial: dataToSend.razonSocial.toUpperCase(),
               // name: dataToSend.nombre.toUpperCase(),
                email: dataToSend.email.trim().toLowerCase(),
                rfc: dataToSend.rfc.trim().toUpperCase(),
                telefono: dataToSend.telefono || null,
                direccion: dataToSend.direccion || null
            });

            if (result.error) {
                showError(result.data || 'Error al registrar usuario');
                setLoading(false);
                return;
            }

            const { token, user } = result.data.data;

            setStorage('data', { token });
            setStorage('user', user);
            setIsLogged(true);

            showSuccess('Registro exitoso ');

            setTimeout(() => {
                navigate('/welcome');
            }, 1500);

        } catch (err) {
            showError('Error de conexión. Por favor, intenta nuevamente.');
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="back-to-landing-container">
                <button className="back-to-landing" onClick={() => navigate('/sign-in')}>
                    ← Volver al Login
                </button>
            </div>

            <div className="login-container signup-container">
                <div className="login-logo">
                    <div className="logo-login" onClick={() => navigate("/")}>
                        <img
                            src="https://cdn2.paraty.es/mariabonita-corpo/images/15cba433451f2bd=s250"
                            height="46"
                            alt="María Bonita Logo"
                        />
                    </div>
                </div>

                <h2 className="login-title">Registro de Proveedor</h2>
                <p className="login-subtitle">Crea tu cuenta para empezar a trabajar con nosotros</p>


                <form onSubmit={handleSubmit}>
                    {/* Información Personal */}
                    <div className="form-section">
                        <h3 className="form-section-title">Información Personal</h3>

                        <div className="form-group">
                            <label className="form-label">Nombre Completo *</label>
                            <input
                                type="text"
                                name="nombre"
                                className={`form-input ${errors.nombre ? 'input-error' : ''}`}
                                placeholder="Juan Pérez"
                                value={formData.nombre}
                                onChange={handleChange}
                                disabled={loading}
                            />
                            {errors.nombre && (
                                <span className="error-message">{errors.nombre}</span>
                            )}
                        </div>

                        <div className="form-group">
                            <label className="form-label">Correo Electrónico *</label>
                            <input
                                type="email"
                                name="email"
                                className={`form-input ${errors.email ? 'input-error' : ''}`}
                                placeholder="usuario@ejemplo.com"
                                value={formData.email}
                                onChange={handleChange}
                                disabled={loading}
                            />
                            {errors.email && (
                                <span className="error-message">{errors.email}</span>
                            )}
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label className="form-label">Contraseña *</label>
                                <input
                                    type="password"
                                    name="password"
                                    className={`form-input ${errors.password ? 'input-error' : ''}`}
                                    placeholder="••••••••"
                                    value={formData.password}
                                    onChange={handleChange}
                                    disabled={loading}
                                />
                                {errors.password && (
                                    <span className="error-message">{errors.password}</span>
                                )}
                            </div>

                            <div className="form-group">
                                <label className="form-label">Confirmar Contraseña *</label>
                                <input
                                    type="password"
                                    name="confirmPassword"
                                    className={`form-input ${errors.confirmPassword ? 'input-error' : ''}`}
                                    placeholder="••••••••"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    disabled={loading}
                                />
                                {errors.confirmPassword && (
                                    <span className="error-message">{errors.confirmPassword}</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Información de la Empresa */}
                    <div className="form-section">
                        <h3 className="form-section-title">Información de la Empresa</h3>

                        <div className="form-group">
                            <label className="form-label">RFC *</label>
                            <input
                                type="text"
                                name="rfc"
                                className={`form-input ${errors.rfc ? 'input-error' : ''}`}
                                placeholder="XAXX010101000"
                                value={formData.rfc}
                                onChange={handleChange}
                                maxLength="13"
                                disabled={loading}
                            />
                            {errors.rfc && (
                                <span className="error-message">{errors.rfc}</span>
                            )}
                        </div>

                        <div className="form-group">
                            <label className="form-label">Razón Social *</label>
                            <input
                                type="text"
                                name="razonSocial"
                                className={`form-input ${errors.razonSocial ? 'input-error' : ''}`}
                                placeholder="Mi Empresa S.A. de C.V."
                                value={formData.razonSocial}
                                onChange={handleChange}
                                disabled={loading}
                            />
                            {errors.razonSocial && (
                                <span className="error-message">{errors.razonSocial}</span>
                            )}
                        </div>

                        <div className="form-group">
                            <label className="form-label">Teléfono</label>
                            <input
                                type="tel"
                                name="telefono"
                                className={`form-input ${errors.telefono ? 'input-error' : ''}`}
                                placeholder="(555) 123-4567"
                                value={formData.telefono}
                                onChange={handleChange}
                                disabled={loading}
                            />
                            {errors.telefono && (
                                <span className="error-message">{errors.telefono}</span>
                            )}
                        </div>

                        <div className="form-group">
                            <label className="form-label">Dirección</label>
                            <textarea
                                name="direccion"
                                className="form-input form-textarea"
                                placeholder="Calle, Número, Colonia, Ciudad, Estado, C.P."
                                value={formData.direccion}
                                onChange={handleChange}
                                rows="3"
                                disabled={loading}
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-full"
                        disabled={loading}
                    >
                        {loading ? 'Registrando...' : 'Crear Cuenta'}
                    </button>

                    <div className="register-link">
                        <p>
                            ¿Ya tienes cuenta? <Link to="/sign-in">Iniciar sesión</Link>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
};